module.exports = __webpack_public_path__ + "img/kzb1.d657ac33.jpg";